module.exports = __webpack_public_path__ + "img/engineer.491631d4.svg";